import { computed } from 'vue'

import { IMessage } from '@shared/models/proto/base/messages'
import { Nullable } from '@shared/models/types/primary'
import { numeric } from '@shared/utils/helpers/numeric-formatter'

import { MessageType } from '@protos/chat/message_type_pb'

import { useMessagesStore } from '@pc/store/messages'

export const useMessagePayload = () => {
  const messagesStore = useMessagesStore()
  const messages = computed(() => messagesStore.messages.data)

  const lastMessage = computed<Nullable<IMessage>>(
    () => (messages.value?.data ?? [])[0] ?? null
  )
  const lastMessageId = computed(() => numeric(lastMessage.value?.id))

  const botPayload = computed(() => {
    const content = lastMessage.value?.payload?.content ?? null
    return content?.case === 'botPayload' ? content.value : null
  })

  const inputType = computed(() => {
    const messageType = lastMessage.value?.messageType
    if (!messageType) {
      return null
    }

    switch (messageType) {
      case MessageType.QUICK_FORM:
        return 'QuickForm'
      case MessageType.AUDIO_VIDEO_TEST:
        return MessageType.AUDIO_VIDEO_TEST
      case MessageType.QUICK_REPLY:
        return 'QuickReply'
      case MessageType.SCHEDULER:
        return 'SelfScheduler'
      case MessageType.SIGN_OFF:
        return 'SignOff'
      case MessageType.QUINCY_PAY:
        return MessageType.QUINCY_PAY
      default:
        return 'TextInput'
    }
  })

  return {
    botPayload,
    lastMessageId,
    inputType,
  }
}
